// extracted by mini-css-extract-plugin
module.exports = {"CardsContainer":"SOD_CardsContainer__K2098","Card":"SOD_Card__3bTSy","Value":"SOD_Value__2u2j0","Parameter":"SOD_Parameter__1qCfQ"};